module.exports = __webpack_public_path__ + "static/media/fondo.732911c4.png";